import { modules } from "byzantine";
import Account from "byzantine/src/Account";
import type {
  WebSection,
  WebSectionId
} from "byzantine/src/dbbl/businessLogic/modules/userDisplayPreferences";
import type App from "byzantine/src/App";
import type { InstitutionFeatures } from "byzantine/src/types";
import { renderSection } from "../Dashboard.sections";
import { SECTION_COLUMN_SIZES } from "../DashboardCustomization/constants";
import DashboardCustomization from "../DashboardCustomization/DashboardCustomization";
import { DashboardSectionContext } from "../types";
import { useUserFeatures } from "../../../components/contexts/UserFeaturesContext";
import NarmiDashboardTile from "../../../src/modules/narmiTiles/NarmiDashboardTile";

const DashboardSection = ({
  sectionId,
  sectionContext
}: {
  sectionId: WebSectionId;
  sectionContext: DashboardSectionContext;
}) => {
  const tile = modules.narmiTiles.useSectionTile(sectionId);
  const { aoiob } = useUserFeatures() as InstitutionFeatures;
  const visibleServices = sectionContext.servicesApps ?? [];

  const servicesCount = visibleServices.length + (aoiob ? 1 : 0);
  const isTwoColumn = sectionId === "services" && servicesCount > 4;

  return (
    <div
      className={`dashboard-section dashboard-section--span-${
        isTwoColumn ? 2 : SECTION_COLUMN_SIZES[sectionId] ?? 1
      }`}
    >
      {tile ? (
        <NarmiDashboardTile tile={tile} />
      ) : (
        renderSection(sectionId, sectionContext)
      )}
    </div>
  );
};

const LargeViewportLayout = ({
  sections,
  externalAccounts,
  servicesApps,
  sectionContext
}: {
  sections: WebSection[];
  externalAccounts: Account[];
  servicesApps: App[];
  sectionContext: DashboardSectionContext;
}) => (
  <>
    {sections.map(({ section_id: sectionId }) => (
      <DashboardSection
        key={sectionId}
        sectionId={sectionId}
        sectionContext={sectionContext}
      />
    ))}
    <div className="dashboard-section--span-2">
      <DashboardCustomization
        externalAccounts={externalAccounts}
        servicesApps={servicesApps}
      />
    </div>
  </>
);

export default LargeViewportLayout;
